import React from 'react'
import { Box } from 'grommet'
// import { StaticQuery, graphql } from "gatsby"
// import Img from "gatsby-image"
import styled, { keyframes } from 'styled-components'

const rotation = keyframes`
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
`
// const SpinningImg = styled(Image)`

// `

const Wheel = styled(Box)`
  width: 30rem;
  height: 30rem;
  border-radius: 50%;
  position: relative;
  background-image: ${props => props.colorsString};
  animation: ${rotation} 0.2s infinite linear;
  &:after {
    content: '';
    width: 8rem;
    height: 8rem;
    position: absolute;
    background-color: white;
    border-radius: 50%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`
// ["#34222e", "#e2434b", "#f9bf8f", "#fee9d7"],
const SpinningWheel = ({ toolColors }) => {
  const pieAngle = 360 / toolColors.length
  let tempColorString = 'conic-gradient('
  for (let i = 0; i < toolColors.length; i++) {
    let j = i
    if (toolColors.length > 2) {
      // to avoid 2 colors pallete
      if (i === 1) {
        j = 2
      } else if (i === 2) {
        j = 1
      }
    }
    tempColorString =
      tempColorString + `${toolColors[j]} 0 ${pieAngle * (i + 1)}deg, `
  }
  const colorsString = tempColorString.slice(0, -2) + ')'
  // const colorsString = `conic-gradient(
  //       ${toolColors[0]} 0 90deg,
  //       ${toolColors[2]} 0 180deg,
  //       ${toolColors[1]} 0 270deg,
  //       ${toolColors[3]} 0 360deg
  //     )`
  return (
    <Box
      width="30rem"
      height="30rem"
      align="center"
      justify="center"
      alignSelf="center"
    >
      <Wheel colorsString={colorsString} />
    </Box>
  )
}

export default SpinningWheel
